module.exports = __webpack_public_path__ + "static/img/logo52.34e17c4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo52.png
// module id = 7ubp
// module chunks = 1